export const typeOfSaleList = {
    DEALER_SALE: "Accredited dealer",
    PRIVATE_SALE: "Private sale",
    MID_TERM_REFINANCE: "Mid-term refinance",
    BALLOON_RESIDUAL_REFINANCE: "Balloon | Residual Refinance",
    SALE_BUYBACK_EQUITY: "Sale & buyback | Equity"
}

export const assetTypes = {
    MOTOR_VEHICLE_UNDER_4_5_TONNES: "Motor Vehicle (<4.5 tonnes)",
    COMMERCIAL_SMALL_MEDIUM_LESS_THAN_12_TONNES: "Commercial (Small to Medium) Vehicles (<12 Tonnes)",
    COMMERCIAL_HEAVY_VEHICLE_GREATER_THAN_12_TONNES: "Commercial (Heavy) Vehicles (>12 Tonnes)",
}

export const productTypes = [
    "Standard",
    "Low doc",
    "Light doc",
    "Full doc",
    "Adverse"
];

export const livingArrangementsTypes = {
    PROPERTY_OWNER: "Property owner",
    SPOUSE_OWNED_PROPERTY: "Spouse owned property",
    RENTING: "Renting",
    BOARDING: "Boarding",
    LIVING_WITH_PARENTS: "Living w/ parents"
}

export const rentingBoardingLiving = [
    livingArrangementsTypes.RENTING,
    livingArrangementsTypes.BOARDING,
]

export const criteriaTypes = [
    "No deposit",
    "No property",
];

export const commercialLenderList = [
    "Angle Finance",
    "ANZ",
    "Azora Asset Finance",
    "Captial Finance",
    "Finance One",
    "Flexi",
    "Group & General Finance",
    "GRENKE",
    "Grow",
    "Liberty",
    "Macquarie",
    "Metro",
    "Pepper",
    "Plenti",
    "resimac",
    "ScotPac",
    "Selfco",
    "Shift",
    "Westpac",
]

export const consumerLenderList = [
    "Finance One",
    "Greenlight",
    "Liberty",
    "Macquarie",
    "Money3",
    "MoneyPlace",
    "NOW",
    "Pepper",
    "Plenti",
    "WISR"
]

export const sortList = [
    ["fit", "desc"],
    ["repayments", "asc"],
    ["rate", "asc"],
    ["loanAmount", "asc"],
    ["fees", "asc"],
];

export const employmentTypes = {
    FULL_TIME: "Full-time",
    PART_TIME: "Part-time",
    CASUAL: "Casual",
    CONTRACT: "Contract",
    SELF_EMPLOYED: "Self employed",
    BENEFITS: "Benefits"
}

export const emailStatus = {
    CURRENT: "current",
    PREVIOUS: "previous",
}

// Keep in sync with USER_TYPE on the server
export const userTypes = {
    USER: "user",
    // Manages their organisation and sees its users
    ADMIN: "admin",
    // GGF staff, who see every organisation's users and applications
    MASTER: "master",
};

export const userTypeLabels = {
    [userTypes.USER]: "User",
    [userTypes.ADMIN]: "Admin",
    [userTypes.MASTER]: "Master",
};

// Keep in sync with USER_STATUS on the server
export const userStatus = {
    ACTIVE: "active",
    DEACTIVATED: "deactivated",
    SUSPENDED: "suspended",
    // Registered and waiting for GGF to approve the registration
    PENDING_APPROVAL: "pendingApproval",
};

// Keep in sync with ORGANISATION_STATUS on the server
export const organisationStatus = {
    PENDING_APPROVAL: "pendingApproval",
    ACTIVE: "active",
    // Its users can't sign in, except master users
    DEACTIVATED: "deactivated",
};

// Whether a user's email address is verified. Keep in sync with EMAIL_STATUS on the server
export const emailVerificationStatus = {
    VERIFIED: "verified",
    UNVERIFIED: "unverified",
};

// How the users and organisations pages show statuses: an active user or organisation is approved
export const userStatusLabels = {
    [userStatus.ACTIVE]: "Approved",
    [userStatus.PENDING_APPROVAL]: "Pending approval",
    [userStatus.DEACTIVATED]: "Deactivated",
    [userStatus.SUSPENDED]: "Suspended",
};

export const organisationStatusLabels = {
    [organisationStatus.ACTIVE]: "Approved",
    [organisationStatus.PENDING_APPROVAL]: "Pending approval",
    [organisationStatus.DEACTIVATED]: "Deactivated",
};

export const emailVerificationStatusLabels = {
    [emailVerificationStatus.VERIFIED]: "Verified",
    [emailVerificationStatus.UNVERIFIED]: "Unverified",
};

// The palette colour of the dot master users see before each status they can change: done, waiting or stopped.
// Grey for any other
export const userStatusColors = {
    [userStatus.ACTIVE]: "success",
    [userStatus.PENDING_APPROVAL]: "warning",
    [userStatus.DEACTIVATED]: "error",
};

export const organisationStatusColors = {
    [organisationStatus.ACTIVE]: "success",
    [organisationStatus.PENDING_APPROVAL]: "warning",
    [organisationStatus.DEACTIVATED]: "error",
};

export const emailVerificationStatusColors = {
    [emailVerificationStatus.VERIFIED]: "success",
    [emailVerificationStatus.UNVERIFIED]: "warning",
};

// What master users can change statuses to on those pages, from a status's dropdown. Keep in sync with STATUS_CHANGE
// on the server
export const userStatusChanges = [
    { value: userStatus.ACTIVE, label: "Approve" },
    { value: userStatus.DEACTIVATED, label: "Deactivate" },
];

export const organisationStatusChanges = [
    { value: organisationStatus.ACTIVE, label: "Approve" },
    { value: organisationStatus.DEACTIVATED, label: "Deactivate" },
];

export const emailVerificationStatusChanges = [
    { value: emailVerificationStatus.VERIFIED, label: "Verified" },
    { value: emailVerificationStatus.UNVERIFIED, label: "Unverified" },
];

export const statusChangeMessages = {
    SAVING: "Saving",
    GENERIC_ERROR: "Something went wrong. Please try again.",
};

// Inviting users from the users page. Keep in sync with INVITATION on the server
export const maxInvites = 10;
export const invitationLinkDays = 7;
// The register link in the invitation email carries the invitation in this query parameter
export const invitationQueryParam = "invite";
// Who can invite people, and as what: only master users invite admins
export const invitableUserTypes = {
    [userTypes.MASTER]: [userTypes.USER, userTypes.ADMIN],
    [userTypes.ADMIN]: [userTypes.USER],
};

export const invitationMessages = {
    GENERIC_ERROR: "Something went wrong. Please try again.",
    ORGANISATION_REQUIRED: "Please select an organisation.",
    ORGANISATIONS_FAILED: "We couldn’t load the organisations. Please try again.",
    FIRST_NAME_REQUIRED: "Please enter their first name.",
    NAME_INVALID: "Name can contain only letters, dashes (-) or spaces.",
    EMAIL_REQUIRED: "Please enter their email address.",
    EMAIL_INVALID: "Please enter a valid email address.",
    EMAIL_DUPLICATE: "This email address is already in the list.",
    LINK_CHECK_FAILED: "We couldn’t check your invitation. Please try again.",
};

export const pageRoutes = {
    REGISTER: "/register",
    LOGIN: "/login",
    FORGOT_PASSWORD: "/password/forgot",
    PRIVACY: "/privacy",
    RESET_PASSWORD: "/reset-password",
    APPLICATIONS: "/dashboard/applications",
    CUSTOMERS: "/dashboard/customers",
    USERS: "/dashboard/users",
    ORGANISATIONS: "/dashboard/organisations",
    ACCOUNT_PROFILE: "/account/profile",
    ACCOUNT_ORGANISATION: "/account/organisation",
    ACCOUNT_SETTINGS: "/account/settings",
    // Where the email verification and registration approval links land. Keep in sync with PLATFORM_PAGE on the server
    EMAIL_VERIFIED: "/email-verified",
    EMAIL_VERIFICATION_FAILED: "/email-verification-failed",
    REGISTRATION_APPROVED: "/request-success",
    REGISTRATION_ALREADY_APPROVED: "/request-already-approved",
    REGISTRATION_APPROVAL_FAILED: "/request-fail",
  };

export const registrationMessages = {
    GENERIC_ERROR: "Something went wrong. Please try again.",
    BUSINESS_CHECK_FAILED: "We couldn’t check this business. Please select it again.",
};

// Login second factor. OTP_REQUIRED / MOBILE_REQUIRED match LOGIN_STEP returned by the server
export const loginSteps = {
    CREDENTIALS: "credentials",
    OTP_REQUIRED: "otpRequired",
    MOBILE_REQUIRED: "mobileRequired",
};

export const loginCodeLength = 6;

// Login request in flight: SUBMIT is the step's main button, RESEND the resend code link
export const loginRequests = {
    SUBMIT: "submit",
    RESEND: "resend",
};

export const loginMessages = {
    GENERIC_ERROR: "Something went wrong. Please try again.",
    CODE_RESENT: "We’ve sent you a new code.",
};

// Screens of the forgot password card
export const forgotPasswordSteps = {
    REQUEST: "request",
    SENT: "sent",
};

export const passwordMessages = {
    RULES: "Must contain an uppercase letter, a number, a special character (!@$%&*) and be at least 8 characters long.",
    MISMATCH: "Your passwords do not match.",
};

export const validationMessages = {
    INVALID_EMAIL: "Invalid email",
};

export const stateList = [
"Australian Capital Territory",
"New South Wales",
"Northern Territory",
"Queensland",
"Tasmania",
"Victoria",
"Western Australia",
"South Australia",
];

export const assetConditionList = [
    "New",
    "Demo",
    "Used",
]

export const maxAssetsLimit = 2;

export const declarationAnswers = {
    YES: "yes",
    NO: "no",
};

export const documentNames = {
    PRIVACY_AGREEMENT: "Privacy agreement",
    BANK_STATEMENTS: "Bank statements",
    DRIVER_LICENCE: "Driver licence",
    DRIVER_LICENCE_FRONT: "Driver licence (front)",
    DRIVER_LICENCE_BACK: "Driver licence (back)",
    ID_DOCUMENT: "ID document",
};

// Any of these satisfies the driver licence requirement
export const driverLicenceDocumentNames = [
    documentNames.DRIVER_LICENCE,
    documentNames.DRIVER_LICENCE_FRONT,
    documentNames.DRIVER_LICENCE_BACK,
];

// Documents previewed above the upload buttons in the Identity section
export const identityPreviewDocumentNames = [
    ...driverLicenceDocumentNames,
    documentNames.ID_DOCUMENT,
];
